import React, { useEffect, useState } from "react";

import { API } from "../../constants/Api";
import { format } from "date-fns";
import { toast } from "react-toastify";
import { Modal } from "antd";
import DataTable from "react-data-table-component";
import { useLocation, useNavigate } from "react-router-dom";

function ZipCodeDetail() {
  const token = localStorage.getItem("token");

  const location = useLocation()
const navigate = useNavigate()
  const {data} = location.state || []; // Combined data for tours and offers
  const {type} = location.state || ""; // Combined data for tours and offers
  const {zipc} = location.state || ""; // Combined data for tours and offers

  const [selectedData, setSelectedData] = useState([]);
  const [user, setUser] = useState([]);
  const [update, setUpdate] = useState(0);
  const [reason, setReason] = useState("");
  const [openResponsive, setOpenResponsive] = useState(false);
  const [openResponsive2, setOpenResponsive2] = useState(false);
  const [openReason, setOpenReason] = useState(false);
  const [openReason2, setOpenReason2] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [activeTab, setActiveTab] = useState("Advertiser");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  // Fetch data for tours and offers
 
  // Fetch user details

  // Open modal for selected lead
 
  // Handle approve/disapprove actions

  // Columns for DataTable
  const columns = [
    {
      name: "Name",
      selector: (row) => row.name,

      sortable: true,
      minWidth: "200px",
    },

    {
      name: "Zip Code",
      cell: (row) => (
        <span
          className="tour-status-completed-1 my-3"
      
        >
             {zipc}
        </span>
      ),
      sortable: true,
      minWidth: "200px",
      center: true,
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
      minWidth: "200px",
      right: true,
    },
 
  

  ];


  // Custom styles for DataTable
  const customStyles = {
    table: {
      style: {
        backgroundColor: "#252525!important",
      },
    },
    headCells: {
      style: {
        backgroundColor: "#1e1e1e",
        color: "#ffffff",
        fontSize: "16px",
        fontFamily: "Degular-Light",
      },
    },
    cells: {
      style: {
        fontSize: "14px",
        color: "#ffffff",
      },
    },
    rows: {
      style: {
        backgroundColor: "#252525",
        fontFamily: "Degular-Light",
      },
      highlightOnHoverStyle: {
        backgroundColor: "#e3f2fd",
        transition: "0.2s ease-in-out",
      },
    },
    pagination: {
      style: {
        backgroundColor: "#1e1e1e",
        fontSize: "14px",
        borderTop: "1px solid #ddd",
        color: "#ffffff",
      },
      pageButtonsStyle: {
        color: "#ffffff",
        fill: "#ffffff",
        "&:hover": {
          backgroundColor: "#252525",
          color: "#ffffff",
          fill: "#ffffff",
        },
        "&:disabled": {
          color: "#bdbdbd",
          fill: "#bdbdbd",
        },
      },
    },
  };

  return (
    <div className="agent-lead">
      <h2 className="user-layout-page-heading">{type} <span className="float-right" style={{color: "#d4bb98", fontSize: "16px", cursor: "pointer"}} onClick={()=>{navigate("/admin-auth/admin-zips")}}><i class="bi bi-arrow-left-circle" style={{color: "#d4bb98", fontSize: "26px"}}></i></span></h2>
    
      {loading ? (
            <div className="wait-loader">
              <div className="spinner-grow text-light" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <div className="container-fluid agent-buy-leads-container">
              <div className="row">
                {data.length > 0 ? (
                  <div className="col-12 px-0 pt-4">
                    <DataTable
                      columns={columns}
                      data={data}
                      pagination
                      paginationPerPage={15}
                      paginationRowsPerPageOptions={[10, 15, 20, 50]}
                      customStyles={customStyles}
                      progressPending={false}
                      progressComponent={
                        <div className="text-center my-2 bg-white">
                          <div
                            className="spinner-border text-secondary"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </div>
                      }
                      className="table table-striped table-hover"
                    />
                  </div>
                ) : (
                  <div className="col-12 px-0 d-flex justify-content-center align-items-center flex-column">
                    <img
                      src="/img/leadership-empty.svg"
                      className="img-fluid"
                      alt=""
                    />
                    <h2 className="leadership-empty-heading">
                      It’s Empty here!
                    </h2>
                    <p className="leadership-empty-para mt-2">
                      Look’s like you haven’t scheduled any tours or offers.
                    </p>
                  </div>
                )}
              </div>
            </div>
          )}
    </div>
  );
}

export default ZipCodeDetail;
